module.exports = __webpack_public_path__ + "img/loading.efbac2db.gif";